export type NotificationReadVia = 'bell_open' | 'bell_dismiss' | 'bell_mark_all' | 'history_open' | 'push_click'

export type NotificationClientType = 'desktop_browser' | 'mobile_browser' | 'pwa_android' | 'pwa_ios' | 'unknown'

export type NotificationReadContext = {
  read_via: NotificationReadVia
  client_type: NotificationClientType
  client_user_agent: string
}

function isIosDevice(): boolean {
  if (typeof navigator === 'undefined') {
    return false
  }
  const ua = navigator.userAgent
  return /iPad|iPhone|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}

function isAndroidDevice(): boolean {
  return typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent)
}

function isStandaloneDisplay(): boolean {
  if (typeof window === 'undefined') {
    return false
  }
  const nav = navigator as Navigator & { standalone?: boolean }
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches ||
    nav.standalone === true
  )
}

export function detectNotificationClientType(): NotificationClientType {
  if (typeof navigator === 'undefined') {
    return 'unknown'
  }
  const ua = navigator.userAgent
  const standalone = isStandaloneDisplay()
  if (standalone && isAndroidDevice()) {
    return 'pwa_android'
  }
  if (standalone && isIosDevice()) {
    return 'pwa_ios'
  }
  if (isAndroidDevice() || isIosDevice() || /Mobile/i.test(ua)) {
    return 'mobile_browser'
  }
  return 'desktop_browser'
}

export function buildNotificationReadContext(readVia: NotificationReadVia): NotificationReadContext {
  return {
    read_via: readVia,
    client_type: detectNotificationClientType(),
    client_user_agent: typeof navigator !== 'undefined' ? navigator.userAgent.slice(0, 512) : '',
  }
}
